import React, { useEffect, useState } from "react";
import Modal from "components/common/Modal";

const ModalExpiratedToken = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      setIsOpenModal(true);
    };

    window.addEventListener("session-expired", handleSessionExpired);

    return () => {
      window.removeEventListener("session-expired", handleSessionExpired);
    };
  }, []);

  const handleClose = () => {
    sessionStorage.removeItem("@csh-brasil-refresh");

    setIsOpenModal(false);
    window.location.reload();
  };

  return (
    <div className="container">
      <Modal
        show={isOpenModal}
        title="Sua sessão expirou! :("
        onClose={handleClose}
      >
        Recarregue sua página.
      </Modal>
    </div>
  );
};

export default ModalExpiratedToken;
